/**
 * Zip a set of named byte blobs and trigger a browser download. fflate is
 * loaded via dynamic import so it only enters the bundle when an export runs.
 */

/**
 * The download itself is the app-wide one, re-exported here so a caller that
 * zips and a caller that saves a photo go through the same anchor.
 */
export { downloadBlob } from '../utils/downloadFile';
import { downloadBlob } from '../utils/downloadFile';

const ZIP_MIME = 'application/zip';
const XLSX_MIME =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** Wrap raw bytes in a Blob (the typed-array generic isn't a BlobPart in TS). */
function bytesToBlob(bytes: Uint8Array, mime: string): Blob {
    return new Blob([bytes as unknown as BlobPart], { type: mime });
}

/** Download raw bytes under a filename (defaults to the .xlsx MIME type). */
export function downloadBytes(
    bytes: Uint8Array,
    filename: string,
    mime: string = XLSX_MIME
): void {
    downloadBlob(bytesToBlob(bytes, mime), filename);
}

/**
 * Zip a set of named byte blobs into a single .zip Blob.
 *
 * `level` is fflate's compression level. Leave it alone for text; pass 0 for a
 * bag of JPEGs, which do not compress and would otherwise be walked byte by
 * byte for nothing.
 */
export async function zipToBlob(
    files: Record<string, Uint8Array>,
    options: { level?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 } = {}
): Promise<Blob> {
    const { zipSync } = await import('fflate');
    return bytesToBlob(zipSync(files, options), ZIP_MIME);
}
